<template>
  <div :class="total ===0 ?'item-box-content':'item-box-content-bottom'">
    <div :style="{height: tableHeight+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="dataList"
        :max-height="tableHeight"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
        @row-dblclick="RowDbclick"
      >
        <template slot="empty">
          <no-data :nodata="`nodataPurchase`">暂无数据</no-data>
        </template>
        <el-table-column
          show-overflow-tooltip
          min-width="120"
          :key="1"
          prop="pcbNumber"
          label="合同编号"
        >
          <template slot-scope="scope">
            <div
              class="line-limit-length approval"
              @click="pcbNumberClick(scope.row)"
            >{{scope.row.pcbNumber}}</div>
          </template>
        </el-table-column>
        <el-table-column
          :key="2"
          show-overflow-tooltip
          min-width="120"
          prop="supplierContractNumber"
          label="供应商合同编号"
        ></el-table-column>
        <el-table-column
          prop="signDate"
          v-if="activeName ==='采购中'||activeName ==='已采购'"
          label="签订时间"
          :key="3"
          min-width="140"
        >
          <template slot-scope="scope">{{scope.row.signDate|dateFilterHM}}</template>
        </el-table-column>
        <el-table-column :key="4" show-overflow-tooltip min-width="100" prop="suName" label="供应商名称">
          <template slot-scope="scope">
            <div
              class="line-limit-length approval"
              @click="suNameClick(scope.row)"
            >{{scope.row.suName}}</div>
          </template>
        </el-table-column>
        <el-table-column :key="5" show-overflow-tooltip prop="ocspCode" label="工单编号"></el-table-column>
        <el-table-column :key="6" show-overflow-tooltip prop="stockupType" label="备货方式"></el-table-column>
        <el-table-column :key="7" show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column :key="8" show-overflow-tooltip prop="proType" label="型号">
          <template slot-scope="scope">
            <div
              class="line-limit-length approval"
              @click="proTypeClick(scope.row)"
            >{{scope.row.proType}}</div>
          </template>
        </el-table-column>
        <el-table-column :key="9" show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column :key="10" show-overflow-tooltip prop="proExtype" label="类型"></el-table-column>
        <el-table-column :key="11" prop="cbExtimeValue" label="货期">
          <template slot-scope="scope">{{scope.row.cbExtimeValue+'天'}}</template>
        </el-table-column>
        <el-table-column :key="12" prop="pccCount" label="数量"></el-table-column>
        <el-table-column :key="13" prop="purchasePrice" label="采购单价">
          <template slot-scope="scope">{{scope.row.purchasePrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column :key="14" prop label="采购总额">
          <template slot-scope="scope">
            {{
            ( scope.row.pccCount * scope.row.purchasePrice)|priceFilterNum
            }}
          </template>
        </el-table-column>

        <el-table-column :key="15" show-overflow-tooltip prop="storageName" label="备货仓库"></el-table-column>
        <el-table-column :key="16" prop="deliveryTime" label="预计发货时间" width="140px">
          <template slot-scope="scope">{{scope.row.deliveryTime|dateFilter}}</template>
        </el-table-column>
        <el-table-column
          :key="17"
          v-if="activeName !== '采购审核'"
          prop="deliverState"
          label="发货状态"
          width="120px"
        ></el-table-column>
      </el-table>
    </div>
    <div class="pagination" v-show="total!==0" style="margin-top:20px;">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import pagination from '@/components/pagination'
import { deepClone } from '@/util'
import noData from '@/components/module/noData'

export default {
  props: ['dataList', 'currentPage', 'pageSize', 'total', 'activeName', 'tableHeight'],
  components: {
    pagination: pagination,
    noData
  },
  data () {
    return {
      dataListState: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回',
        '盖章审批'
      ],
      listStockUp: [{}],
      cbPriceSource: ['系统', '人工', '特价审批', '其他'],
      waitMoveList: []

    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    RowDbclick (row) {
      this.$emit('waitMoveList', [row])
      this.waitMoveList = []
    },
    pcbNumberClick (row) {
      if (row.contractState === 4) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '已履行', pcbId: row.pcbId }
        })
      } else if (row.contractState === 3) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '履行中', pcbId: row.pcbId }
        })
      } else {
        let typeData = ''
        typeData = this.dataListState[row.contractState - 1]
        this.$router.push({
          name: 'createContract',
          query: { type: typeData, pcbId: row.pcbId }
        })
      }
    },
    suNameClick (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    proTypeClick (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.proId }
      })
    },
    moveInPlan () {
      if (this.waitMoveList.length !== 0) {
        this.$emit('waitMoveList', deepClone(this.waitMoveList))
        this.waitMoveList = []
      } else {
        this.$message.error('请选中要移入采购区的产品！')
      }
    },
    handleSelectionChange (value) {
      this.waitMoveList = value
    },
    handleSizeChange (val) {
      this.$emit('handleSizeChange', val)
    },
    // 页码
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter,
    dateFilterHM
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
function dateFilterHM (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.item-box-content-bottom {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 20px 20px 0 20px;
  font-size: 14px;
  border-radius: 4px;

  .config-instruction {
    padding: 10px 0px 10px 20px;
  }
}
</style>
